document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach(acc => {
    const header = acc.querySelector(".accordion-header");

    header.addEventListener("click", () => {
      // Close all other accordions
      accordions.forEach(other => {
        if (other !== acc) {
          other.classList.remove("open");
        }
      });

      // Toggle the clicked one
      acc.classList.toggle("open");
    });
  });
});


document.querySelectorAll('.view-button').forEach(button => {
  button.addEventListener('click', function () {
    const imageColumn = button.closest('.image-column');
    if (imageColumn) {
      const hoverImg = imageColumn.querySelector('.hover-img');
      if (hoverImg) {
        hoverImg.classList.toggle('display-image');
      }
    }
  });
});